export const filterOldCategory = {
  component: 'Buttons',
  mobileComponent: 'Buttons',
  multiple: false,
  currentValue: null,
  defaultValue: 'residenziale',
  values: [
    {
      display: 'residenziale',
      value: 'residenziale',
      count: 0,
    },
    {
      display: 'commerciale',
      value: 'commerciale',
      count: 0,
    },
    {
      display: 'vacanze',
      value: 'vacanze',
      count: 0,
    },
  ],

  excludeValues: {},
  dependsOn: null,
  updates: null,

  label: 'Categoria',
  labelOnly: 'Categoria',
  humanDefaultValue: 'Residenziale',
  humanValueMeasureUnit: '',
  containerCssClass: null,
  itemCssClass: 'filter-btn button',
  disabledByCount: false,
  isNew: false,
  resetButton: true,
};

// publication_date: {
//   component: 'Select',

//   optionsStatic: true,

//   defaultValue: 'all',
//   values: [
//     {
//       display: 'qualsiasi',
//       value: 'all',
//       count: 0,
//     },
//     {
//       display: 'ultime 24 ore',
//       value: '24h',
//       count: 0,
//     },
//     {
//       display: 'ultime 48 ore',
//       value: '48h',
//       count: 0,
//     },
//     {
//       display: 'ultima settimana',
//       value: '7days',
//       count: 0,
//     },
//     {
//       display: 'ultimo mese',
//       value: '30days',
//       count: 0,
//     },
//   ],
//   excludeValues: {},
//   dependsOn: null,
//   updates: null,
//   label: 'Data di pubblicazione',
//   labelOnly: 'Data di pubblicazione',
//   humanDefaultValue: 'Qualsiasi',
//   humanValueMeasureUnit: '',
//   containerCssClass: null,
//   itemCssClass: `${filterBtnClass} button`,
//   resetButton: true,
// },
